import { AmenityApi, Configuration } from "hotdesk_typescript";

export class AmenitiesService {
    amenitiesApi: AmenityApi;

    constructor(apiConfig: Configuration) {
        this.amenitiesApi = new AmenityApi(apiConfig)
    }
    async getAmenities(idIn: string, browserLanguage: string) {
        const params = {
            limit: 200,
            offset: 0,
            lang: browserLanguage
        };
        if (idIn) return await this.amenitiesApi.amenityList({ idIn, ...params });
        return await this.amenitiesApi.amenityList(params);
    }
}
